import { render, staticRenderFns } from "./RomaNotification.vue?vue&type=template&id=3c77a8da"
import script from "./RomaNotification.vue?vue&type=script&lang=ts"
export * from "./RomaNotification.vue?vue&type=script&lang=ts"
import style0 from "./RomaNotification.vue?vue&type=style&index=0&id=3c77a8da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports